/* --------------------------------------------------------------------------------------
   jobSettings.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { apiJobSettingNames } from "../constants/jobSettings.const"

const settingsReducer = (obj, item) => ({
    ...obj,
    [getApiFriendlyName(item[0])]: item[1]["key"].replace("__SIZE", "")
})

const settingsReducerNoApiNames = (obj, item) => ({
    ...obj,
    [item[0]]: item[1]["key"].replace("__SIZE", "")
})

const getApiFriendlyName = prop => apiJobSettingNames[prop] ? apiJobSettingNames[prop] : prop

export const getSelectedJobSettings = (settings, noApiNames) => Object.entries(settings)
    .reduce(noApiNames ? settingsReducerNoApiNames : settingsReducer, [])